<template>
  <div class="add-to-cart-container">
    <form class="add-to-cart-form" @submit.prevent.stop="onAddToCart(products)">
      <div v-if="showLoader && isAddingCart" class="button add-to-cart-loader" :class="[...buttonClasses]">
        <slot name="loader">
          <span class="loader tiny"></span>
        </slot>
      </div>
      <button
        v-else
        ref="addToCartButton"
        class="add-cart-button"
        name="addToCart"
        type="submit"
        aria-label="Add to cart"
        :class="[...buttonClasses]"
      >
        <slot>Add To Cart</slot>
      </button>
    </form>
  </div>
</template>

<script>
import useAddToCart from '@/compositions/useAddToCart.js';

export default {
  name: 'BaseCartButton',
  props: {
    scrollFirst: {
      type: Boolean,
      default: true,
    },
    products: {
      type: Array,
      required: true,
    },
    animate: {
      type: Boolean,
      default: false,
    },
    showLoader: {
      type: Boolean,
      default: false,
    },
    buttonClasses: {
      type: Array,
      default: () => ['filled', 'coral'],
    },
  },
  setup(props, context) {
    const { addCartProcess, isAddingCart } = useAddToCart();

    async function onAddToCart(products) {
      context.emit('beforeAdded', products);

      await addCartProcess({
        products,
        buttonToAnimate: props.animate && context.refs.addToCartButton,
        scrollFirst: props.scrollFirst,
      });

      if (context.root.$options.router?.history?.current?.path !== '/cart') {
        context.root.$store.dispatch('common/notifyCartItemsAdded');
      }

      context.emit('added', products);
    }

    return {
      isAddingCart,
      onAddToCart,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~@article/pixel/dist/style/variables';

.add-to-cart-container {
  .add-to-cart-form {
    display: initial;

    .add-cart-button {
      white-space: nowrap;
    }
  }
}
</style>
